import styled from 'styled-components';

export const ErrorMessageStyled = styled.p`
  color: ${props=> props.theme.colors.error};
  font-size: 12px;
  line-height: 166%;
`